import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import InstallPrompt from './InstallPomt';
const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    console.log('Opció d’instal·lació:', result.outcome);
    setDeferredPrompt(null);
    setShowInstall(false);
  };

  return (
    <>
      {showInstall && (
        <Button onClick={handleInstallClick}>
            <InstallPrompt />
         <InstallMobileIcon></InstallMobileIcon>
        </Button>
      )}
    </>
  );
};

export default InstallPWA;
